const imgData = [
  { name: 'Lu Bu', img: './imgs/lubu.png' },
  { name: 'Guan Yu', img: './imgs/guanyu.png' },
  { name: 'Zhao Yun', img: './imgs/zhaoyun.png' },
  { name: 'Zhang Fei', img: './imgs/zhangfei.png' },
  { name: 'Ma Chao', img: './imgs/machao.png' },
  { name: 'Huang Zhong', img: './imgs/huangzhong.png' },
  { name: 'Xiahou Dun', img: './imgs/xiahoudun.png' },
  { name: 'Xu Zhu', img: './imgs/xuzhu.png' },
  { name: 'Xiahou Yuan', img: './imgs/xiahouyuan.png' },
  { name: 'Zhang Liao', img: './imgs/zhangliao.png' },
  { name: 'Xu Huang', img: './imgs/xuhuang.png' },
  { name: 'Zhou Yu', img: './imgs/zhouyu.png' },
  { name: 'Lu Xun', img: './imgs/luxun.png' },
  { name: 'Taishi Ci', img: './imgs/taishici.png' },
  { name: 'Lu Meng', img: './imgs/lumeng.png' },
  { name: 'Gan Ning', img: './imgs/ganning.png' },
  { name: 'Jiang Wei', img: './imgs/jiangwei.png' },
  { name: 'Wei Yan', img: './imgs/weiyan.png' },
  { name: 'Ma Dai', img: './imgs/madai.png' },
  { name: 'Zhang He', img: './imgs/zhanghe.png' },
  { name: 'Cao Ren', img: './imgs/caoren.png' },
  { name: 'Pang De', img: './imgs/pangde.png' },
  { name: 'Huang Gai', img: './imgs/huanggai.png' },
  { name: 'Sun Ce', img: './imgs/sunce.png' },
  { name: 'Zhou Tai', img: './imgs/zhoutai.png' },
];

let index = 0;
for (let i = 0; i < imgData.length; i++) {
  let j = i % 5;
  let star = 5 - j;
  const chances = [1, 7, 13, 19, 60];
  const mulPowers = [140000, 12000, 1100, 105, 10];
  const basePowers = [100000, 10000, 1000, 100, 10];
  const mints = [10000, 1000, 100, 10, 1];

  imgData[i].star = star;
  imgData[i].power = basePowers[index] + (mulPowers[index] * (star - 1));
  imgData[i].chance = chances[j];
  imgData[i].mintFee = mints[index];
  const img = imgData[i].img;
  imgData[i].img = img.replace('./imgs/', 'https://res.cloudinary.com/dey55ubjm/image/upload/v1633669304/rtkw/');
  // 'https://fathomless-taiga-78317.herokuapp.com/imgdata/' + i;
  // https://res.cloudinary.com/dey55ubjm/image/upload/e_auto_contrast/v1633669304/rtkw/zhaoyun.png
  // 'https://res.cloudinary.com/dey55ubjm/image/upload/v1633669304/rtkw/'
  if (star === 1) index++;

}

module.exports = {
  GAS: 'CFX',
  USDT: 'USDT',
  TOKEN: 'DRG',
  TOKEN_NAME: 'Dragon Token',
  IMG_WIDE: 'https://res.cloudinary.com/dey55ubjm/image/upload/v1634395509/rtkw/lubuw.png',
  IMG_DATA: imgData,
};


